
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busonrentinpunetoashtavinayak() {



    const cardData =
    {
        keyword: 'Bus on Rent for Pune to Ashtavinayak Darshan',
        heading: 'Amruta Travels: Bus on Rent for Pune to Ashtavinayak Darshan',
        headingDescription: 'Amruta Travels offers Bus on Rent for Pune to Ashtavinayak Darshan, providing a reliable and comfortable transportation solution for your spiritual journey to the eight revered Ganpati temples in Maharashtra. Whether you are planning a family pilgrimage, group tour, or corporate outing, our well-maintained buses ensure a smooth and devotional experience. Choose from our range of buses, including 32-seater, 35-seater, 40-seater, 45-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your Ashtavinayak Darshan from Pune simple and stress-free. Book your bus with Amruta Travels and embark on a journey of faith and comfort!',


        top: 'Top Places to Visit in Ashtavinayak with Amruta Travels',
"topPlaces": [
  {
    "title": "Mayureshwar Temple, Morgaon",
    "description": "Located in Morgaon, Pune district, this temple is considered the starting and ending point of the Ashtavinayak Yatra. The deity here, Mayureshwar, is depicted riding a peacock, symbolizing the slaying of the demon Sindhu. The temple's architecture features a central shrine surrounded by a spacious courtyard and four minarets, resembling a mosque—a design choice made to protect it during invasions."
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "Situated on the banks of the Bhima River in Ahmednagar district, this temple is unique for its right-trunked Ganesha idol, which is considered especially powerful. The temple is accessible via a bridge and a series of steps, offering a serene environment for devotees seeking success and spiritual enlightenment."
  },
  {
    "title": "Ballaleshwar Temple, Pali",
    "description": "Located in Pali, Raigad district, this temple is named after the devoted child Ballal, who was blessed by Ganesha. It's the only temple where Ganesha is known by his devotee's name. The temple's design allows sunlight to fall directly on the deity during specific times of the year, enhancing its spiritual ambiance."
  },
  {
    "title": "Varadvinayak Temple, Mahad",
    "description": "Situated in Mahad, Raigad district, this temple is known for fulfilling devotees' wishes. The idol here is self-manifested (Swayambhu) and is placed in a sanctum that allows devotees to perform rituals directly. The temple is surrounded by a serene pond and lush greenery, providing a tranquil setting for worship."
  },
  {
    "title": "Chintamani Temple, Theur",
    "description": "Located in Theur, Pune district, this temple is associated with the legend of Ganesha retrieving the precious Chintamani jewel for sage Kapila. The temple's architecture includes a spacious hall and a sanctum housing the idol with a left-turned trunk, symbolizing peace and prosperity."
  },
  {
    "title": "Girijatmaj Temple, Lenyadri",
    "description": "Set within the Buddhist caves of Lenyadri near Junnar, this temple is unique as it's the only Ashtavinayak temple situated in a cave. The deity here is believed to be the child form of Ganesha, and the temple requires a climb of 307 steps, offering panoramic views of the surrounding landscape."
  },
  {
    "title": "Vighneshwar Temple, Ozar",
    "description": "Located in Ozar, Pune district, this temple is associated with the legend of Ganesha defeating the demon Vighnasur, who caused obstacles. The temple features a gold-plated dome and houses an idol with rubies for eyes and a diamond on the forehead, symbolizing the removal of obstacles."
  },
  {
    "title": "Mahaganapati Temple, Ranjangaon",
    "description": "Situated in Ranjangaon, Pune district, this temple is believed to be where Ganesha defeated the demon Tripurasura. The idol here is depicted with eight arms, symbolizing strength and power. The temple's architecture includes a spacious hall and a sanctum that houses the imposing idol."
  }
],



  "services": [
    {
      "name": "Pune to Ashtavinayak Bus Tour Package",
      "description": "Amruta Travels offers a well-organized Pune to Ashtavinayak Bus Tour Package covering all eight revered Ganpati temples across Maharashtra. With expert planning, experienced drivers, and clean buses, this tour is ideal for spiritual seekers and family groups."
    },
    {
      "name": "Pune to Ashtavinayak Bus Tour Package With Amruta Travels",
      "description": "Embark on a comfortable spiritual journey with Amruta Travels’ Ashtavinayak Tour Package from Pune. Our buses are equipped with AC, cushioned seats, and onboard support to ensure a serene and fulfilling darshan experience of all eight temples."
    },
    {
      "name": "Cheapest Ashtavinayak Tour From Pune",
      "description": "Looking for a budget-friendly pilgrimage? Amruta Travels offers the cheapest Ashtavinayak Tour from Pune without compromising on safety and service. Perfect for groups, senior citizens, and families wanting value-for-money spiritual travel."
    },
    {
      "name": "Ashtavinayak Tour From Pune by Bus Package",
      "description": "Join Amruta Travels on a guided Ashtavinayak tour by bus from Pune. The package includes temple visits, breaks for meals, and seamless road travel. It’s an ideal option for groups who prefer an all-in-one pilgrimage experience."
    },
    {
      "name": "Pune Ashtavinayak Darshan Tour Package",
      "description": "This Pune-based Ashtavinayak Darshan package from Amruta Travels is carefully designed to cover all eight temples in a timely and relaxed manner. Our expert itinerary ensures a spiritually enriching experience without the hassle of planning."
    },
    {
      "name": "Ashtavinayak Darshan From Pune in 2 Days",
      "description": "Amruta Travels offers a 2-day Ashtavinayak Darshan from Pune, ideal for those who wish to cover the entire yatra over a weekend. Enjoy a spiritual retreat with overnight stay options and well-paced travel to each temple."
    },
    {
      "name": "Pune to Ashtavinayak Darshan AC Sleeper Bus on Rent",
      "description": "Travel in comfort with Amruta Travels’ AC Sleeper Bus rental for Ashtavinayak Darshan. Perfect for overnight journeys and long road trips, our sleeper coaches provide relaxing and safe transportation for pilgrims."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Bus Booking",
      "description": "Easily book your Ashtavinayak Darshan bus from Pune with Amruta Travels. We offer a hassle-free online and offline booking system, confirmed itineraries, and timely service to ensure a smooth religious journey."
    },
    {
      "name": "Pune to Ashtavinayak Ganpati Darshan Package",
      "description": "Explore all eight Ganpati temples of the Ashtavinayak circuit with Amruta Travels’ bus packages. Our experienced team curates a spiritually fulfilling experience with planned stops, comfortable travel, and temple insights."
    },
    {
      "name": "Best Ashtavinayak Tour From Pune Amruta Travels",
      "description": "Recognized for service and reliability, Amruta Travels offers the best Ashtavinayak Tour from Pune. Ideal for groups, families, and senior citizens, our buses are clean, timely, and accompanied by helpful staff for a memorable pilgrimage."
    },
    {
      "name": "Ashtavinayak Yatra From Pune Amruta Travels",
      "description": "Join the Ashtavinayak Yatra with Amruta Travels from Pune and experience Maharashtra’s most significant Ganesh temples in one organized journey. Our yatra includes guided routes, group coordination, and devotional ambience throughout."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Mini Bus On Rent",
      "description": "Rent a mini bus from Pune for a private Ashtavinayak Darshan with Amruta Travels. Suitable for small groups and families, our mini buses offer personalized travel, AC comfort, and expert drivers familiar with temple routes."
    }
  ],
  "tableData": [
    ["Pune to Ashtavinayak Bus Tour Package", "Pune to Ashtavinayak Bus Tour Package With Amruta Travels"],
    ["Cheapest Ashtavinayak Tour From Pune", "Ashtavinayak Tour From Pune by Bus Package"],
    ["Pune Ashtavinayak Darshan Tour Package", "Ashtavinayak Darshan From Pune in 2 Days"],
    ["Pune to Ashtavinayak Darshan AC Sleeper Bus on Rent", "Pune to Ashtavinayak Darshan Bus Booking"],
    ["Pune to Ashtavinayak Ganpati Darshan Package", "Best Ashtavinayak Tour From Pune Amruta Travels"],
    ["Ashtavinayak Yatra From Pune Amruta Travels", "Pune to Ashtavinayak Darshan Mini Bus On Rent"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Bus on Rent for Pune to Ashtavinayak Darshan",
    "WhyChoosedescription": "Amruta Travels offers reliable and comfortable bus rental services for the sacred Ashtavinayak Darshan Yatra starting from Pune. Covering the eight revered Ganesh temples across Maharashtra, this spiritual journey requires efficient travel planning and dependable transport. Our well-maintained buses and experienced team ensure that your pilgrimage is smooth, serene, and spiritually fulfilling."
  },
  {
    "WhyChooseheading": "Ideal for Devotees, Family Groups, and Pilgrimage Tours",
    "WhyChoosedescription": "Our Pune to Ashtavinayak bus service is perfect for religious groups, senior citizen yatras, families, and spiritual tour organizers. Whether you’re planning a single-day Darshan or a two-day itinerary with halts and temple visits, we tailor the travel experience to suit your group’s pace, comfort level, and devotional requirements."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses for a Peaceful Journey",
    "WhyChoosedescription": "Choose from our range of AC and Non-AC buses including 17, 20, 32, 35, 40, 45, and 50-seater options. All buses are clean, comfortable, and equipped with push-back seats, large windows, and ample storage. Designed for long pilgrim routes, our vehicles ensure a fatigue-free journey as you travel from one sacred temple to the next."
  },
  {
    "WhyChooseheading": "Knowledgeable and Devoted Drivers for Smooth Travel",
    "WhyChoosedescription": "Our experienced drivers are familiar with the Ashtavinayak circuit, including the best routes, temple timings, and nearby amenities. Their respectful and supportive nature ensures a devotional atmosphere throughout your journey, while their punctuality and route knowledge keep the trip well on schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries with Multiple Pickup Points",
    "WhyChoosedescription": "We offer full customization of your Ashtavinayak Darshan plan from Pune. Whether you want to visit all 8 temples in one day or stretch it over two days with overnight stays, we adapt to your needs. We can also arrange pickups from multiple locations across Pune for the convenience of your group."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Amruta Travels provides budget-friendly rates for Ashtavinayak Darshan bus rentals. Our transparent pricing includes fuel, tolls, parking, and driver allowances, so you won’t face any last-minute surprises. We aim to make this sacred journey accessible and stress-free for everyone."
  },
  {
    "WhyChooseheading": "Clean, Safe, and Devotee-Friendly Travel Experience",
    "WhyChoosedescription": "We prioritize passenger safety and cleanliness. All buses are regularly sanitized, and drivers adhere to safe driving practices, especially on narrow temple roads. The environment inside the bus is respectful and devotional, making it suitable for chanting, bhajans, or spiritual discussions during travel."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking and Support Throughout the Journey",
    "WhyChoosedescription": "Booking your Pune to Ashtavinayak Darshan bus is easy via our online portal, customer service hotline, or office visit. Our dedicated travel coordinators assist with itinerary planning, temple sequences, and even meal halt suggestions. We remain available throughout the journey to address any queries or last-minute adjustments."
  }
]
















    }

const faqData = [
  {
    question: 'How can I rent a bus for Ashtavinayak Darshan from Pune?',
    answer: 'You can easily rent a bus for the Ashtavinayak Darshan from Pune by contacting Amruta Travels via phone, our website, or visiting our office. We’ll help you select the right bus and create a travel plan that covers all eight Ganpati temples comfortably.',
  },
  {
    question: 'What is included in the Ashtavinayak Darshan bus package?',
    answer: 'Our package includes a well-maintained bus with an experienced driver, fuel, tolls, and parking. You can also opt for add-ons like a guide, meal arrangements, and hotel stays depending on your group’s requirements.',
  },
  {
    question: 'Which buses are available for the Ashtavinayak Darshan trip?',
    answer: 'We offer a variety of buses including 32, 35, 40, 45, and 50-seater options in AC and non-AC configurations. Luxury and deluxe buses are also available for added comfort during the pilgrimage.',
  },
  {
    question: 'Is it possible to complete the Ashtavinayak Darshan in one day?',
    answer: 'Yes, a one-day Ashtavinayak Darshan trip is possible with early departure from Pune. However, for a more relaxed experience, many prefer the 2-day package which includes an overnight stay.',
  },
  {
    question: 'Can I customize the itinerary for the Ashtavinayak tour?',
    answer: 'Absolutely! You can customize pickup/drop locations, travel dates, temple order, and halts based on your group’s preferences. We’ll help plan the most efficient route.',
  },
  {
    question: 'Are meals or food stops included in the trip?',
    answer: 'We include planned halts at clean and hygienic restaurants en route. Meal arrangements can be pre-booked on request or managed independently during the journey.',
  },
  {
    question: 'Is the driver familiar with the Ashtavinayak route?',
    answer: 'Yes, all our drivers are experienced with the Ashtavinayak Darshan route and ensure a safe, smooth, and timely journey covering all eight temples.',
  },
  {
    question: 'What is the cost of a bus rental for the Ashtavinayak trip?',
    answer: 'The cost varies based on bus size, AC or non-AC preference, duration (1-day or 2-day), and any additional services. Contact us for a detailed and transparent quote.',
  },
  {
    question: 'Why choose Amruta Travels for Ashtavinayak Darshan bus hire?',
    answer: 'Amruta Travels provides reliable service with clean, well-maintained buses, courteous drivers, and customizable packages that ensure a spiritual and comfortable pilgrimage experience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ajay Kulkarni',
    role: 'Family Group Organizer, Pune',
    text: 'We booked a 40-seater bus for our family’s Ashtavinayak Darshan with Amruta Travels. The experience was excellent – the driver knew the route well and all temples were covered smoothly. Very satisfied!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meena Patil',
    role: 'Senior Citizen Group Leader',
    text: 'Our senior citizen group hired a luxury bus for the Ashtavinayak tour. It was comfortable and well-organized. The staff took good care of our needs and the journey was spiritually fulfilling. Thank you!',
    rating: 5,
  },
];































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Darshan Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-ashtavinayak.jpg",
  "description": "Book your Ashtavinayak Darshan tour from Pune with Amruta Travels. We offer customized bus packages including AC sleeper buses, mini buses, and group travel for a memorable trip to the eight sacred Ganesh temples in Maharashtra. Our affordable and comfortable options ensure a smooth pilgrimage journey.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "14720"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000", // Adjust price as needed for specific packages
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-ashtavinayak-darshan-bus-hire"
  }
};




    return (
        <div>



<Helmet>
  <title>Call: +91 7353109555 | Pune to Ashtavinayak Darshan Bus Hire | AC Sleeper, Mini Bus, Yatra Package | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book your Ashtavinayak Darshan bus tour from Pune with Amruta Travels. Offering affordable, comfortable AC buses, sleeper buses & mini buses for the sacred Ashtavinayak yatra." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busonrentinpunetoashtavinayak;